__turbopack_context__.v({
  "addDetailsButton": "styles-module__1ao6xa__addDetailsButton",
  "errorRow": "styles-module__1ao6xa__errorRow",
  "groupContainer": "styles-module__1ao6xa__groupContainer",
  "groupDescription": "styles-module__1ao6xa__groupDescription",
  "groupItemError": "styles-module__1ao6xa__groupItemError",
  "groupItemErrorIcon": "styles-module__1ao6xa__groupItemErrorIcon",
  "groupItemErrorName": "styles-module__1ao6xa__groupItemErrorName",
  "groupItemIcon": "styles-module__1ao6xa__groupItemIcon",
  "groupItemName": "styles-module__1ao6xa__groupItemName",
  "groupItemNameFilled": "styles-module__1ao6xa__groupItemNameFilled",
  "groupItemNameText": "styles-module__1ao6xa__groupItemNameText",
  "groupItemNameWrapper": "styles-module__1ao6xa__groupItemNameWrapper",
  "groupMoreButton": "styles-module__1ao6xa__groupMoreButton",
  "groupsContainer": "styles-module__1ao6xa__groupsContainer",
  "groupsTitle": "styles-module__1ao6xa__groupsTitle",
  "groupsWrapper": "styles-module__1ao6xa__groupsWrapper",
  "hidden": "styles-module__1ao6xa__hidden",
  "optional": "styles-module__1ao6xa__optional",
  "subtext": "styles-module__1ao6xa__subtext",
});
